import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {GetApp,LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList, FormatListNumbered,ConfirmationNumber,HourglassEmpty,Check,Close} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Link,Slide
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService,ReportingService,AdminService,FinanceService} from "./../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { format } from "date-fns/esm";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},
paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    height:300,
    elevation:0
  },appBar: {
    position: 'relative',
  },title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
}));





 function ReportRura() {
  const classes = useStyles1();

  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [reportsMessage,setReportsMessage]=useState("Filter report within specific date...");
  const [reportTitle,setReportTitle]=useState("RURA Report");

  const history = useHistory();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//offenses table 


const columns = [
  {
    name: "ticketId",
    label: "Ticket ID",
    options: {
     filter: true,
     sort: true,
  //    customBodyRender: (value, tableMeta, updateValue) => {
  //     return (<Typography color="primary"><Link href="#" onClick={()=>{
  //      get_detailed_report(value);
  //     }}>
  //       {value}
  //     </Link>
  //     </Typography>
  //     );
  //  }
    }
   },
   {
    name: "customerFullNames",
    label: "Customer Fullnames",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "route",
   label: "Route",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "source",
    label: "Source",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "destination",
    label: "Destination",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "plateNbr",
    label: "Plate Number",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "price",
    label: "Fare",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "posId",
    label: "POS ID",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "agent",
    label: "Agent",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "departureTime",
    label: "Departure Time",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "departureTime",
    label: "Departure Datetime",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "date",
    label: "Requested Date",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: true,
    }
   }

 ];

 
 const options = {textLabels: {
  body: {
    noMatch: reportsMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View details" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 console.log("ticket id",id);
}} />
      </Box>
  ),
 };

 const [isDownload,setIsDownload]=useState(false);


 useEffect(()=>{
  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }
  setOperatorData(data);
  // get_sales_report_download(data.token);
  // get_sales_report(data.token);
 },[]);

 const getDate=()=>{
    return Format(new Date(), ["yyyy-MM-dd",]);
 }



 const [amounts,setAmounts]=useState([]);
 const [labels,setLabels]=useState([]); 

 const [revenue,setRevenue]=useState([]);

 const [currency,setCurrency]=useState("");



 const pos_performance= 
{options:{
    series: [],
    chart: {
    width: 380,
    type: 'pie',
  },
  
  labels: labels,
  legend: {
    position: 'right',
    itemMargin:{
        horizontal:0
    }
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 280,
        height:280
      },
      legend: {
        position: 'right'
      }
    }
  }]
  }
}




// pos revenue 


const revenue_pos=
{
    options:{
        series: [{
        name: 'Revenue',
        data: revenue
      }],
        chart: {
        height: 350,
        type: 'bar',
        tools:{
            download: false,
            selection:false,
            pan:false,
            reset:false,
          }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          distributed: false,
          startingShape: "flat",
          columnWidth: '5px',
          dataLabels: {
            enabled: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return formatMoney(parseInt(val),0)+ " ";
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#304758"]
        }
      },
      
      xaxis: {
        categories: labels ,
        position: 'bottom',
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            }
          }
        },
        tooltip: {
          enabled: true,
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val + " ";
          }
        }
      
      },
      
      }
};



//   get rura report 


const [startDate,setStartDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [endDate,setEndDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});

const [totalTickets,setTotalTickets]=useState(0);
const [totalAmount,setTotalAmount]=useState(0);

const [reportLoad,setReportLoad]=useState(false);
const [reports,setReports]=useState([]);
const get_sales_report=(token)=>{
setReportLoad(true);


axios.defaults.baseURL = new ReportingService().BASE_URL;
const reportInstance = axios.create(new ReportingService().setHeaders(token));
reportInstance.post('/extra-reports/pullDailyTicketsList',
{
  "company_id": new UserInfo().ORG_ID,
  "end_date": endDate.value+" 23:59:59",
  "start_date": startDate.value+" 00:00:00"
})
.then(res=>{
    console.log("response",res.data)
    // const url = window.URL.createObjectURL(new Blob([res.data]));
    // const link = document.createElement('a');
    // link.href = url;
    // // link.setAttribute('download', 'file.xlsx'); //or any other extension
    // document.body.appendChild(link);
    // link.click();

    /////////////////////////////////////

    setFilterDialog(false);
    var objs=res.data.data;
    var curr="";
    console.log("=====  report =====",objs);
    if(objs.length==0){
        setReportsMessage("No report available today");
    }else{
      var l=[];
      var s=[];
      var tot_tickets=0;
      var tot_amount=0;
      setReports(objs);

    //////////////////////////////////

    objs.map((o)=>{
      l.push(o['channel_type']);
      s.push(parseInt(o['total_amount']));
      o['amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency'];
      curr=o['currency'];
      tot_tickets=tot_tickets+parseInt(o['total_tickets']);
      tot_amount=tot_amount+parseInt(o['total_amount']);
      o['price'] = formatMoney(o['price'],0)+" "+o['currency'];
    });
      setTotalTickets(tot_tickets);
      setTotalAmount(formatMoney(parseInt(tot_amount),0));
      setLabels(l);
      setAmounts(s);
      setRevenue(s);

      setReports(objs);
      setCurrency(curr);
    }
    setReportLoad(false);
})
.catch(err=>{
 
  setReportLoad(false);
  if(err.response){
    enqueueSnackbar(err.response.data.message,
      { 
        variant: 'error'
    });
  }

  if(err.message){
    setReportsMessage(err.message);
    enqueueSnackbar(err.message,
      { 
        variant: 'error'
    });
  }
   
    
});

}




const get_sales_report_download=(token)=>{
  setReportLoad(true);
  
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const reportInstance = axios.create(new ReportingService().setHeadersFile(token));
  reportInstance.post('/extra-reports/downloadDailyTicketsList',
  {
    "company_id": new UserInfo().ORG_ID,
    "end_date": endDate.value+" 23:59:59",
    "start_date": startDate.value+" 00:00:00"
  }
  )
  .then(res=>{

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    const file_name="tickets_list_"+Format(new Date(), ["yyyy-MM-dd","H-mm-ss"])
    link.setAttribute('download', file_name+'.xlsx');
    document.body.appendChild(link);
    link.click();

    setReportLoad(false);
    setFilterDialog(false);
  })
  .catch(err=>{
   
    setReportLoad(false);
    if(err.response){
      enqueueSnackbar(err.response.data.message,
        { 
          variant: 'error'
      });
    }
  
    if(err.message){
      setReportsMessage(err.message);
      enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
    }
     
      
  });
  
  }



// filter report 






// filter dialog 
const [filterDialog,setFilterDialog]=useState(false);


// filter fines titckets


const [posID,setPosID]=useState({value:null,error:""});

const [channel,setChannel]=useState({value:"all",error:""});


const filter_report=()=>{
    
  setReportLoad(true);


            setTotalTickets(0);
            setTotalAmount(0);
            setLabels([]);
            setAmounts([]);
            setRevenue([]);    
            setReports([]);

    var data={};

    if(channel.value=="all"){
      data={"organization_id":new UserInfo().ORG_ID,
      "chanel_type":"","start_date":startDate.value,"end_date":endDate.value};
    }else{
      data={"organization_id":new UserInfo().ORG_ID,
      "chanel_type":channel.value,"start_date":startDate.value,"end_date":endDate.value};
    }

    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    reportInstance.post('/traffic-report/daily-sales-report',data)
    .then(res=>{
        var objs=res.data.data;
        console.log("=====  report =====",objs);
        if(objs.length==0){
            setReportsMessage("No sales report available today");
        }else{
          var l=[];
          var s=[];
          var tot_tickets=0;
          var tot_amount=0;
          objs.map((o)=>{
            l.push(o['channel_type']);
            s.push(parseInt(o['total_amount']));
            o['amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency'];
            tot_tickets=tot_tickets+parseInt(o['total_tickets']);
            tot_amount=tot_amount+parseInt(o['total_amount']);
          });
            setTotalTickets(tot_tickets);
            setTotalAmount(formatMoney(parseInt(tot_amount),0));
            setLabels(l);
            setAmounts(s);
            setRevenue(s);    
            setReports(objs);
            
            setFilterDialog(false);
        }

        setReportTitle("Sales report From : "+startDate.value+" To : "+endDate.value);
       
        setReportLoad(false);
    })
    .catch(err=>{
     
      setReportLoad(false);
      if(err.response){
        enqueueSnackbar(err.response.data.message,
          { 
            variant: 'error'
        });
      }
    
      if(err.message){
        setReportsMessage(err.message);
        enqueueSnackbar(err.message,
          { 
            variant: 'error'
        });
      }
       
        
    });


    
}




// get pos devices

const [devices,setDevices]=useState([]);
const get_devices=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const deviceInstance = axios.create(new TransportService().setHeaders(token));
  deviceInstance.get('/api/v1/integrations/getDevicesByOrganization/'+new UserInfo().ORG_ID)
  .then(res=>{
    setDevices(res.data);
  })
  .catch(err=>{

    if(err.message){

    }

    if(err.response){

    }

  });
}



 // format money 

 function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};




// details table  






const columns1 = [
  { 
    name: "id",
    label: "Route",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
       var obj=detailedReport.find((o)=>o.id==value);
      return (<Button color="primary" onClick={()=>{
        setBusObj(obj);
        get_passenger_tickets(obj);
        setPassengerDialog(true);
      }}>
        {obj['route']}
      </Button>);
   }
    }
   }
  ,
  {
   name: "departure_time",
   label: "Departure Time",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "plate_nbr",
   label: "Plate number",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "total_tickets",
    label: "Total tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
     name: "total_amount",
     label: "Total Amount",
     options: {
      filter: true,
      sort: true,
     }
    }
 ];

 
 const options1 = {textLabels: {
  body: {
    noMatch: "No report available"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
 };




/// daily detailed sales report 

const [detailDialog,setDetailDialog]=useState(false);

const [channel_type,setChannel_type]=useState("")

const [detailedReport,setDetailedReport]=useState([]);
const [detailedLoad,setDetailedLoad]=useState(false);
const get_detailed_report=(channel)=>{
  setChannel_type(channel);
  setDetailedLoad(true);
  setDetailDialog(true);
  setDetailedReport([]);
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const detailedInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  detailedInstance.post('/traffic-report/detailed-daily-sales-report',{
    "organization_id":new UserInfo().ORG_ID,
    "chanel_type":channel,
    "start_date":startDate.value,
    "end_date":endDate.value
  })
  .then(res=>{
    var objs=res.data.data;
    objs.map((o,i)=>{
      o['id']=i+1;
      o['total_amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency']
    });
    setDetailedReport(objs);
    setDetailedLoad(false);
  })
  .catch(err=>{
    setDetailedLoad(false);
  });

}



// passenger tickets 




const columns2 = [
  {
    name: "ticket_id",
    label: "Ticket Number",
    options: {
     filter: true,
     sort: true,
    }
   }
  ,
  {
   name: "client_name",
   label: "Passenger",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "source",
   label: "Source",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "destination",
    label: "Destination",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
     name: "price",
     label: "Price",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "currency",
      label: "Currency",
      options: {
       filter: true,
       sort: true,
      }
     }
 ];

 
 const options2 = {textLabels: {
  body: {
    noMatch: "No report available"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
 };



const [passengerDialog,setPassengerDialog]=useState(false);

const [passengerLoad,setPassengerLoad]=useState(false);

const [passengerTickets,setPassengerTickets]=useState([]);

const [busObj,setBusObj]=useState({});

const get_passenger_tickets=(obj)=>{
  setPassengerTickets([]);
  setPassengerLoad(true);
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const passengerInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  passengerInstance.post('/traffic-report/manifesto-report',{
    "plate_number": obj['plate_nbr'],
    "organization_id": new UserInfo().ORG_ID,
    "departure_time": format(new Date(obj['departure_time']), ["yyyy-MM-dd HH:mm"]),
    "route": obj['route']
}
  )
  .then(res=>{
    var objs=res.data.data;
    objs.map((o)=>{
o['price']=formatMoney(o['price'],0);
    });
    setPassengerTickets(res.data.data);
    setPassengerLoad(false);
  })
  .catch(err=>{
    setPassengerLoad(false);
  });

}



  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><ConfirmationNumber fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>RURA Report</b></Typography>

 </Box>

<Box>
 <Button 
  disableElevation={true}
  style={{marginRight:"10px",textTransform:"capitalize"}}
  color="secondary" 
  variant="outlined"
  startIcon={<GetApp />}
  onClick={()=>{
      setFilterDialog(true); 
      setIsDownload(true);
  }}
  >
 Download Excel
 </Button>

<Button 
  style={{textTransform:"capitalize"}}
  color="primary" 
  variant="outlined"
  startIcon={<FilterList />}
  onClick={()=>{
      setFilterDialog(true);
      setIsDownload(false); 
  }}
  >
      Filter
</Button>
</Box>

</Box>

<Box mt={2}>
{reportLoad&&<LinearProgress/>}
<MUIDataTable
  title={reportTitle}
  data={reports}
  columns={columns}
  options={options}
/>
</Box> 

</div>

{/* filter dialog  */}

<Dialog
    maxWidth="sm"
    fullWidth
        open={filterDialog}
        onClose={()=>{
            setFilterDialog(false);
        }}
        aria-labelledby="filter"
        aria-describedby="filter"
      >
        <DialogTitle id="filter">{"Filter"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            autoOk
                            label="Start date"
                            value={startDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen1: ", Format(v, ["yyyy-MM-dd",]));
                               
                                setStartDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />

          </Box>

          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            
                            autoOk
                            label="End date"
                            value={endDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen2: ",v);
                                setEndDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
            </Box>

          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
              setFilterDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


            
          <Button disabled={reportLoad} onClick={()=>{
            if(isDownload){
              get_sales_report_download(operatorData.token);
            }else{
              get_sales_report(operatorData.token);
            }
          }} color="primary" variant="contained" className={classes.btn}>
              {reportLoad?<CircularProgress size={25} color="secondary"/>:
              <Typography>{isDownload?"Download":"View"}</Typography>
              }
          </Button>


        </DialogActions>
</Dialog>

</MuiPickersUtilsProvider>
  );
}

export default withLocalize(ReportRura);